const DEFAULT_CLASS_MODIFIER = 'default'
const GREEN_CLASS_MODIFIER = 'green'
const RED_CLASS_MODIFIER = 'red'
const YELLOW_CLASS_MODIFIER = 'yellow'

export const priceIndicatorColorConfig = PRICE_INDICATOR_VALUE_RANK => {
  return [
    {
      [PRICE_INDICATOR_VALUE_RANK.first]: RED_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.second]: YELLOW_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.third]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fourth]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fifth]: GREEN_CLASS_MODIFIER
    },
    {
      [PRICE_INDICATOR_VALUE_RANK.first]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.second]: YELLOW_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.third]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fourth]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fifth]: GREEN_CLASS_MODIFIER
    },
    {
      [PRICE_INDICATOR_VALUE_RANK.first]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.second]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.third]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fourth]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fifth]: GREEN_CLASS_MODIFIER
    },
    {
      [PRICE_INDICATOR_VALUE_RANK.first]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.second]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.third]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fourth]: GREEN_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fifth]: GREEN_CLASS_MODIFIER
    },
    {
      [PRICE_INDICATOR_VALUE_RANK.first]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.second]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.third]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fourth]: DEFAULT_CLASS_MODIFIER,
      [PRICE_INDICATOR_VALUE_RANK.fifth]: GREEN_CLASS_MODIFIER
    }
  ]
}

export const SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small'
}

export const NO_OP = () => {}
